'use strict';

var React = require('react');
var Grid = require('../../DesignSystem/Layout/Grid/Grid.js');
var Add = require('../../node_modules/@material-ui/icons/Add.js');
require('prop-types');
var GridWithSpacing = require('../../common/GridWithSpacing.js');
var Typography = require('../../DesignSystem/DataDisplay/Typography/Typography.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var Button = require('../../node_modules/@material-ui/core/esm/Button/Button.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = function styles(theme) {
  return {
    inheritFontColor: {
      color: 'inherit'
    },
    iconItem: {
      display: 'flex'
    },
    titleColor: {
      color: theme.palette.secondary.main,
      '&:hover': {
        color: theme.palette.black.primary
      }
    },
    button: {
      borderRadius: 8,
      border: '1px solid #D8D8D8',
      padding: '10px 16px'
    },
    buttonRoot: {
      textTransform: 'none',
      fontSize: 16,
      color: theme.palette.secondary.light,
      '&:hover': {
        color: theme.palette.black.primary
      }
    }
  };
};

var AlternateButtonWithPlus = function AlternateButtonWithPlus(_ref) {
  var title = _ref.title,
      icon = _ref.icon,
      onClick = _ref.onClick,
      classes = _ref.classes;
  return React__default["default"].createElement(Button["default"], {
    variant: "outlined",
    color: "primary",
    fullWidth: true,
    onClick: onClick,
    className: classes.button,
    classes: {
      root: classes.buttonRoot
    }
  }, React__default["default"].createElement(Grid, {
    container: true,
    alignItems: "center",
    justify: "space-between"
  }, React__default["default"].createElement(Grid, {
    item: true
  }, React__default["default"].createElement(GridWithSpacing, {
    alignItems: "center",
    spacing: 8
  }, React__default["default"].createElement(Grid, {
    item: true,
    className: classes.iconItem
  }, icon), React__default["default"].createElement(Grid, {
    item: true
  }, React__default["default"].createElement(Typography, {
    className: classes.inheritFontColor,
    variant: "body1"
  }, title)))), React__default["default"].createElement(Grid, {
    item: true,
    className: classes.iconItem
  }, React__default["default"].createElement(Add, {
    color: "primary"
  }))));
};

AlternateButtonWithPlus.defaultProps = {
  onClick: function onClick() {}
};
var AlternateButtonWithPlus$1 = withStyles(styles)(AlternateButtonWithPlus);

module.exports = AlternateButtonWithPlus$1;
